<template>
  <div
    @click="closeConnector"
    class="connect-overlay">

    <div @click.stop>
      <input-container
        ref="mainInputContainer"
        @updateValidity="updateValidity"
        class="connector text-center">

        <div class="w-100 float-right close-btn">
          <input-button
            class="mb-2 float-right"
            inputPlaceholder="x"
            slimmer
            variant="standardInput"
            btnStyle="nok-style"
            smaller
            @click="closeConnector" />

        </div>

        <h5>
          Poveži
          <b>
            {{ $t(labelExtension) }}
          </b>
        </h5>

        <div>
          <div
            :id="`container_${f.name}`"
            v-for="f in getInputFields"
            :key="f.name">

            <div
              v-if="isMobileView"
              :id="`${f.name}_mobile`"
              class="tooltip-popup">

              ?
            </div>

            <input-text
              :id="`${f.name}_desktop`"
              :inputName="f.name"
              :inputPlaceholder="$t(f.placeholder)"
              :constraints="getInputConstraints(f.name)"
              variant="standardInput"
              smaller
              @fieldUpdate="fieldUpdate"
              slimmer />

            <b-popover
              :target="getTarget(f.name)"
              :placement="getPlacement"
              triggers="hover"
              :container="`container_${f.name}`"
              ref="popover">

              <template slot="title">
                {{ $t(f.tooltipLabel) }}
              </template>
              <div>
                {{ $t(f.label) }}
              </div>
            </b-popover>

          </div>

          <input-button
            class="mt-2"
            :inputPlaceholder="$t('Button.connect')"
            variant="standardInput"
            btnStyle="ok-style"
            smaller
            centered
            :dissabled="!hasValidInputs"
            @click="connectChannel" />

        </div>
      </input-container>
    </div>
  </div>
</template>

<script>
import InputButton from '@/components/standard/input/InputButton'
import InputText from '@/components/standard/input/InputText'
import InputContainer from '@/components/standard/input/InputContainer'

import authConnector from '@/mixins/standard/connections/authConnector'
import cb from '@/assets/modules/constraints/constraintBuilder'

export default {
  data () {
    return {
      hasValidInputs: false,
      extraParams: {}
    }
  },

  methods: {
    getTarget (baseName) {
      if (this.$store.getters.isMobileView) {
        return `${baseName}_mobile`
      }
      return `${baseName}_desktop`
    },

    fieldUpdate (e) {
      this.$set(this.extraParams, e.input, e.value)
    },

    updateValidity (e) {
      this.$set(this, 'hasValidInputs', e.valid)
    },

    getInputConstraints (name) {
      switch (name) {
        case 'shop':
          return cb.build('url', { onInit: true, required: true })
      }
    }
  },

  computed: {
    getPlacement () {
      return this.$store.getters.isMobileView ? 'top' : 'right'
    },

    getAuthExtension () {
      let base = this.channelType
      let querySeperator = '?'
      for (let ep in this.extraParams) {
        base = `${base}${querySeperator}${ep}=${this.extraParams[ep]}`
        querySeperator = `&`
      }
      return base
    },

    getInputFields () {
      return this.extraFields
    },

    needsExtraParams () {
      return !!this.getInputFields.length
    },

    isMobileView () {
      return this.$store.getters.isMobileView
    }
  },

  mounted () {
    // If channel requires some extra params, prop them like a mutation connector
    if (!this.needsExtraParams) {
      this.connectChannel()
    }
  },

  components: {
    'input-button': InputButton,
    'input-text': InputText,
    'input-container': InputContainer
  },

  props: {
    channelType: {
      type: String,
      required: true,
      default: ''
    },
    labelExtension: {
      type: String,
      required: false,
      default: ''
    },
    extraFields: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  mixins: [
    authConnector
  ]
}

</script>

<style scoped>
.connector {
  background-color: #ffffff;
  border-radius: 4px;
  padding: 15px 30px;
}
.close-btn {
  position: relative;
  right: -15px;
}

.tooltip-popup {
  position: absolute;
  width: 30px;
  height: 30px;
  z-index: 10;
  margin-left: -22px;
  margin-top: 8px;
  border-radius: 100%;
  border: 1px solid #353535;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// src/components/standard/connectors/AuthConnector.vue?336c1880